/* Shared, client-side formatting for the two Voler custom-request forms. */
(() => {
  'use strict';

  const guidance = 'Enter a complete 10-digit U.S. or Canadian phone number, such as (805) 555-0123.';
  const digitsOnly = value => {
    let digits = String(value || '').replace(/\D/g, '');
    if (digits.length > 10 && digits.startsWith('1')) digits = digits.slice(1);
    return digits.slice(0, 10);
  };
  const format = digits => {
    if (!digits) return '';
    if (digits.length <= 3) return '(' + digits;
    if (digits.length <= 6) return '(' + digits.slice(0, 3) + ') ' + digits.slice(3);
    return '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6);
  };
  const plausible = digits => {
    if (!/^[2-9][0-9]{2}[2-9][0-9]{6}$/.test(digits)) return false;
    if (digits.slice(1, 3) === '11' || digits.slice(4, 6) === '11') return false;
    if (/^(\d)\1{9}$/.test(digits)) return false;
    return !['1234567890', '0987654321'].includes(digits);
  };
  const caretAfter = (formatted, count) => {
    if (count < 1) return formatted ? 1 : 0;
    let seen = 0;
    for (let index = 0; index < formatted.length; index++) {
      if (/\d/.test(formatted[index]) && ++seen === count) return index + 1;
    }
    return formatted.length;
  };

  function init(field) {
    if (field.dataset.volerPhoneReady) return;
    field.dataset.volerPhoneReady = 'true';
    const hint = document.createElement('small');
    hint.className = 'vsr__phone-guidance';
    hint.id = field.id + '-guidance';
    hint.setAttribute('aria-live', 'polite');
    hint.hidden = true;
    field.insertAdjacentElement('afterend', hint);
    field.setAttribute('aria-describedby', [field.getAttribute('aria-describedby'), hint.id].filter(Boolean).join(' '));

    function normalize() {
      const original = field.value;
      const startsWithCountry = original.replace(/\D/g, '').startsWith('1');
      const before = original.slice(0, field.selectionStart == null ? original.length : field.selectionStart);
      const count = Math.max(0, before.replace(/\D/g, '').length - (startsWithCountry ? 1 : 0));
      const digits = digitsOnly(original);
      const formatted = format(digits);
      const valid = plausible(digits);
      field.value = formatted;
      if (document.activeElement === field && original !== formatted) {
        const caret = caretAfter(formatted, count);
        field.setSelectionRange(caret, caret);
      }
      field.setCustomValidity(digits && !valid ? guidance : '');
      hint.textContent = digits && !valid ? guidance : '';
      hint.hidden = !digits || valid;
      if (digits && !valid) field.setAttribute('aria-invalid', 'true');
      else field.removeAttribute('aria-invalid');
    }

    field.addEventListener('input', normalize);
    field.addEventListener('change', normalize);
    field.addEventListener('blur', normalize);
    normalize();
  }

  function scan(scope) {
    scope.querySelectorAll('[data-voler-phone]').forEach(init);
  }
  if (typeof document !== 'undefined') {
    scan(document);
    document.addEventListener('shopify:section:load', event => scan(event.target));
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { digitsOnly, format, plausible };
})();
